import React from 'react';
import { Image, Text, View } from 'react-native';
import { getBoldFont, xlateText } from '../../../../utils/Utils';
import { img_lock } from '../../../../utils/ImagesManagementUtils';
import { textPrimary_8_1, textPrimary_9_3 } from '../TextComponent/TextStyle';
//= ========================================================================

const IconNearParagraph = ({
  globJSON,
  simPlatform,
}) => {
  const { colors } = globJSON.configurations.theme;
  const { instructions } = globJSON.configurations.onboarding;

  const myStyles = {
    container: {
      alignItems: 'center',
      flexDirection: 'row',
    },
    lockIconStyle: {
      width: 16,
      height: 16,
      tintColor: colors.primary_cta_color,
      marginLeft: 4,
      position: 'absolute',
    },
    paragraphContainerStyle: {
      marginLeft: 8, width: 170,
    },
    topTitleStyle: {
      fontFamily: `${getBoldFont(globJSON, simPlatform, true)}`,
    },
    square: {
      width: 24,
      height: 24,
      borderRadius: 4.6,
      backgroundColor: (colors.primary_cta_color),
      opacity: 0.2,
    },
  };
  return (
    <View style={myStyles.container}>
      <View style={myStyles.square} />
      <Image
        fadeDuration={0}
        style={myStyles.lockIconStyle}
        source={img_lock}
      />
      <View style={myStyles.paragraphContainerStyle}>
        <Text style={[textPrimary_9_3(globJSON, simPlatform), myStyles.topTitleStyle]}>
          {xlateText(instructions.o_i_your_privacy_title, globJSON)}
        </Text>
        <Text style={[textPrimary_8_1(globJSON, simPlatform), { marginTop: 2 }]}>
          {xlateText(instructions.o_i_your_privacy, globJSON)}
        </Text>
      </View>
    </View>
  );
};
export default IconNearParagraph;
